import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "./../../reducers";
// import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { Combo2Service, WorkOrderService, PurchaseOrderService } from "./../../services/index";
@Component({
  selector: "addEditInvoice",
  templateUrl: "./addItemtype.html",
})
export class addItemtype {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  headList =["F/S", "H/S"];
  nameList = ["1","2" ,"3","4","5","6","7","8"];

  codeList: any;
  seasonList: any;

  execApi: boolean = true;
  //  isEdit: boolean = false;
  invoicedata: any = {};
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  colorList: any = [];
  qualityList: any = [];
  fabColorlist: any = [];
  fabColorTemplist: any = [];

  mode: string;
  saveEvent: any;
  agentList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];

  partyList: any = [];
  varietyList = ["CHECKS","PLAIN"];
  widthList = ["36", "44", "58"];
  styleList = ["FORMAL", "CASUAL"];
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  upd_type: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;
  qualitylist: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];

    this.getSetDetails();
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: WorkOrderService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService

  ) {
 
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    this.tableScroll();
    this.invoicedata.mode = this.mode;

  }
  ngAfterViewInit() {
    $("#invoice_type").focus();
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }


  buttonStyle() {
    const style = {
     Position : "relative",
      left: this.mode == "Add" ? "90%" : "85%",
      bottom: "54px"
    };
    return style;
  }

  addItemDetails() {
    
    if(!this.invoicedata.item_type||!this.invoicedata.prefix){
      swal("ERROR", "Empty Data Not Allowed!!", "error");
      return
    }
   
    if(this.data.invoiceList.find(x=>x.prefix.trim() == this.invoicedata.prefix && !x.isdeleted ))
    
    {
      this.invoicedata.prefix = '';
      swal("ERROR", "PREFIX ALREADY EXIST", "error");
      return;
    }


    delete this.invoicedata.tabevent;

    this.data.invoiceList.push({ ...this.invoicedata }); // If no match found, append at the end
  
    var bottom = document.querySelector("#salesTbody");
    setTimeout(() => {
      bottom.scrollTop = bottom.scrollHeight;
    
    }, 400);

       this.invoicedata.prefix = ''
   

  }
  onEnterKeyPressed(nextEl: string) {

    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }

  }

  getEditMode(ind) {
      
    this.data.invoiceList[ind].isEdit = !this.data.invoiceList[ind].isEdit;
   
  }

  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length >= 1) {

          that.data.invoiceList[ind].isdeleted = true
    
          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) { }
    );
  }
  getSetDetails() {

  let params = {
    page_type : 'Item Type'
  };
    this.salesinvservice.getSetDetails(params).then((res: any) => {
      this.data.invoiceList = res.data;
      var bottom = document.querySelector("#salesTbody");
      bottom.scrollTop = bottom.scrollHeight;
    });
  }




  oncheckemptyrow(){
  
    const seenPriorityCombinations = {}; 
   
    let duplicateFound = false;
    
    this.data.invoiceList.forEach(item => {
        if (item.isdeleted) return; // Skip items marked as deleted
     
        if (seenPriorityCombinations[item.prefix]) {
          swal(`ERROR`, `ALREADY EXISTS`, `error` );
            duplicateFound = true;
        } else {
            seenPriorityCombinations[item.prefix] = true;
        }
  
    });

    //Not Execute the save Part!!
    if(duplicateFound) return
      
    let params: any = Object.assign({}, this.invoicedata);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.data.invoiceList);
    params["page_type"] = 'Item Type';
    let that = this;

    swal({
      title: "Are you sure to save this Changes?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoadMask = that.salesinvservice
        .savesetDetails(params)
        .then(function (res: any) {
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          }
          else {
            swal("This Design" +" " + res.message);
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
 
}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/addItemtype.ts